import { useEffect, useState } from "react";

const ONE_MINUTE = 60_000;

/** Re-renders every `intervalMs`, so a clock reading advances on its own between interactions. */
export function useNow(intervalMs: number = ONE_MINUTE): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return now;
}
